/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import type {
  LoanData,
  LoanRecord,
  RealtimeRepaymentItem,
  RepaymentChannel,
  RepaymentPlanItem,
  SettlementCertificate,
} from '../types';
import { API_BASE_URL, requestJson } from './httpClient';

export const fetchLoan = async () => requestJson<LoanData>(`${API_BASE_URL}/loan`);

export const fetchLoanRecords = async () => requestJson<LoanRecord[]>(`${API_BASE_URL}/loan-records`);

export const fetchRepaymentPlan = async () => requestJson<RepaymentPlanItem[]>(`${API_BASE_URL}/repayment-plan`);

export const fetchRepaymentChannels = async () =>
  requestJson<RepaymentChannel[]>(`${API_BASE_URL}/repayment-channels`);

export const fetchSettlementCertificate = async () =>
  requestJson<SettlementCertificate>(`${API_BASE_URL}/settlement-certificate`);

export const fetchHomeRepayments = async () =>
  requestJson<RealtimeRepaymentItem[]>(`${API_BASE_URL}/home-repayments`);
